// extracted by mini-css-extract-plugin
module.exports = {"container":"StreamingPlatform_container__1Op80","content":"StreamingPlatform_content__3Wcl2","add":"StreamingPlatform_add__BLndf"};